var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipseDownLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 448,
    viewBox: "0 0 394 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.219 458.743C403.273 552.207 262.696 563.165 169.232 483.219C75.7677 403.272 64.8096 262.695 144.756 169.232C224.702 75.7675 365.279 64.8094 458.743 144.756C552.207 224.702 563.165 365.279 483.219 458.743ZM180.031 199.405C116.749 273.387 125.423 384.661 199.405 447.944C273.387 511.226 384.662 502.552 447.944 428.57C511.226 354.588 502.552 243.313 428.57 180.031C354.588 116.749 243.313 125.423 180.031 199.405Z",
    fill: "#FEE7D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.505 419.574C378.938 488.043 275.955 496.071 207.486 437.504C139.016 378.938 130.989 275.955 189.555 207.485C248.122 139.016 351.105 130.988 419.574 189.555C488.044 248.122 496.071 351.105 437.505 419.574ZM193.871 211.177C137.344 277.263 145.092 376.661 211.177 433.188C277.263 489.716 376.661 481.968 433.189 415.882C489.716 349.797 481.968 250.399 415.882 193.871C349.797 137.343 250.399 145.092 193.871 211.177Z",
    fill: "#F2CEB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseDownLogin);
export default __webpack_public_path__ + "static/media/ellipseDownLogin.46dcccf31a80b0c7a3e402609ba78e83.svg";
export { ForwardRef as ReactComponent };